import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Box, Button, CircularProgress } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { UserContext } from "../../../../../../App";
import {
  dataRetriveWhenPageRefresh,
  denominationAPI,
  flushCartNew,
  getManagers,
  validateManagerPin,
} from "../../../../../../config/Services";
import { eventTrackerConstant } from "../../../../../common/event-tracker/event-tracker-constants";
import { eventTracker } from "../../../../../common/event-tracker/eventTracker";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import useGetDevice from "../../../hooks/useGetDevice";
import {
  addLicense,
  addadvance,
  addmanagerpin,
  addmanageruidx,
  addpin,
} from "../../redux/Actions/SessionActions";
import { addcoupon } from "../../redux/Actions/couponActions";
import { resetStateWithoutTime } from "../../redux/Actions/eventTracker";
import { resetDenominations } from "../../redux/Actions/denominationActions";
import { getFullState } from "../../redux/Reducers/eventTrackerReducer";
import { getmangerPin, getmangeruidx, getsessionPin } from "../../redux/Reducers/sessionReducer";
import StyledButton from "../custom/StyledButton";
import StyledSelect from "../custom/StyledSelect";
import "./index.css";
import usePrint from "../../../hooks/usePrint";
import { stopOrderAlert } from "../../../../../../utils/notificationSystem/orderAlertAudio";
import { useNavigate } from "react-router-dom";

const SliderTabManager = ({
  setOpen,
  totalAmountDen,
  comment,
  commentI,
  denoArr,
  sessionData,
  navigate,
  closeTabName = "session",
}) => {
  const isMobile = useGetDevice();
  const showSnackbar = useSnackbar();
  const { startPrint, isPrinting } = usePrint();
  const [isVisible, setVisible] = useState(false);
  const [isVisibleManager, setVisibleManager] = useState(false);
  const { color } = useContext(UserContext);
  const dispatch = useDispatch();
  const [managerDetails, setManagerDetails] = useState([{}]);
  const [selectedManager, setSelectedManager] = useState(null);
  const contextId = localStorage.getItem("locId");
  const [manageBox, setManagerBox] = useState(false);
  const navigateToPath = useNavigate();
  const managerNumber = useSelector(getmangeruidx);
  const mangerPin = useSelector(getmangerPin);
  const cashierPin = useSelector(getsessionPin);
  const [errMessage, setErrMessage] = useState(null);
  const [loader, setLoader] = useState(false);
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  const mobileNumber = retailUserDetails?.mobileNumber;
  const [cashierLoader, setCashierLoader] = useState(false);
  const [errCashMessage, setCashErrMessage] = useState(null);
  const managerUidx = useSelector(getmangeruidx);
  const firstName = retailUserDetails.firstName;
  const secondName = retailUserDetails.secondName;
  const [cPin, setCPin] = useState("");
  const [mPin, setMPin] = useState("");
  const orderMetricDataFullState = useSelector(getFullState);
  const cartId = localStorage.getItem("CartId");
  const retailType = localStorage.getItem("retailType");

  const {
    cartItems,
    setCartItems,
    setCartId,
    setSubTotal,
    total,
    setTotal,
    setCgst,
    setSgst,
    setOfferFound,
    setCess,
  } = useContext(UserContext);

  // ── OLD style object (commented out, replaced by new CSS classes) ──
  // const style = {
  //   backgroundColor: color === "dark" ? "#353a50" : "#fff",
  //   color: color === "dark" ? "white" : "black",
  //   padding: isMobile ? "5%" : "2%",
  //   borderRadius: "10px",
  //   width: isMobile ? "100%" : "50%",
  //   maxWidth: "100vw",
  //   maxHeight: "100%",
  //   position: "fixed",
  //   top: "50%",
  //   left: "0",
  //   transform: `translate(${isMobile ? `0%` : `50%`}, -50%)`,
  //   overflowY: "auto",
  // };

  // ── OLD newSwal mixin (commented out, replaced with styled version below) ──
  // const newSwal = Swal.mixin({
  //   customClass: {
  //     confirmButton: "button button-success",
  //     cancelButton: "button button-error",
  //     container: "close-session-swal-container",
  //   },
  //   buttonsStyling: false,
  // });

  const newSwal = Swal.mixin({
    customClass: {
      popup: "swal-custom-popup",
      htmlContainer: "swal-custom-html",
      confirmButton: "swal-custom-confirm",
      cancelButton: "swal-custom-cancel",
      actions: "swal-custom-actions",
      container: "close-session-swal-container",
      // hide the default title/icon – we render our own header via html
      title: "swal-custom-title-hidden",
      icon: "swal-custom-icon-hidden",
    },
    buttonsStyling: false,
  });

  const toggle = () => {
    setVisible(!isVisible);
  };
  const toggle1 = () => {
    setVisibleManager(!isVisibleManager);
  };

  useEffect(() => {
    const payload = { contextId };
    getManagers(payload).then((res) => {
      const response = res?.data?.data?.map((e) => {
        return {
          value: e?.mobile_number,
          label: e?.first_name,
        };
      });
      setManagerDetails(response);
    });
  }, []);

  const sessionId = localStorage.getItem("sessionId");

  const handleCloseSession = (e) => {
    e.preventDefault();

    setLoader(true);
    let managerpayload = {
      mobile: managerNumber,
      primaryPassword: mPin,
    };
    validateManagerPin(managerpayload)
      .then((res) => {
        newSwal
          .fire({
            // ── Custom HTML header to match Manager Access modal style ──
            html: `
              <div class="swal-modal-header">
                <div class="swal-modal-icon-wrap swal-modal-icon-wrap--warning">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"
                    fill="none" stroke="#fbbf24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                    <line x1="12" y1="9" x2="12" y2="13"/>
                    <line x1="12" y1="17" x2="12.01" y2="17"/>
                  </svg>
                </div>
                <h3 class="swal-modal-heading">Close Session?</h3>
                <p class="swal-modal-desc">This will end the current session. All unsaved data will be finalised. Are you sure you want to proceed?</p>
              </div>
            `,
            // ── title / icon hidden via customClass, content is in html above ──
            showCancelButton: true,
            confirmButtonText: "Yes, Close Session",
            cancelButtonText: "Cancel",
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              try {
                startPrint({
                  sessionData: {
                    ...sessionData,
                    closingBalance: totalAmountDen,
                    reason: comment === "others" ? commentI : comment,
                    denominations: denoArr,
                    managerName: selectedManager,
                  },
                  printType: "report",
                  forcePick: true,
                });
                const payload = {
                  sessionId: sessionId,
                  updatedBy: firstName + " " + secondName,
                  closingBalance: totalAmountDen,
                  reason: comment === "others" ? commentI : comment,
                  denominations: denoArr,
                };
                const response = await denominationAPI(payload);
                if (response?.data?.es > 0) {
                  showSnackbar("Unable to close the session", "error");
                  setOpen(false);
                  setLoader(false);
                  return { error: true, message: "Unable to close the session" };
                }
                showSnackbar("Success session closed", "success");
                stopOrderAlert();
                setLoader(false);
                const closedSessionId = localStorage.getItem("sessionId") || sessionId;
                localStorage.removeItem("sessionId");
                localStorage.removeItem("storeMode");
                dispatch(
                  addLicense({
                    licenseId: "",
                    licenseName: "",
                  })
                );
                dispatch(addadvance(""));
                dispatch(addpin(""));
                dispatch(addmanagerpin(""));
                dispatch(addmanageruidx(""));
                dispatch(resetDenominations());
                setOpen(false);
                handleFlush();
                setTimeout(() => {
                  if (retailType === "RESTAURANT") {
                    // navigateToPath("/session-page/day/closing");
                    navigate("SESSION_CLOSING_PAGE", { closedSessionId });
                  } else {
                    navigate("SESSION_CLOSING_PAGE", { closedSessionId });
                    // navigateToPath("/session-page/start-day");
                  }
                }, 1000);
              } catch (err) {
                newSwal.showValidationMessage(`
          Request failed: ${err}
        `);
              } finally {
                setLoader(false);
              }
            },
            allowOutsideClick: false,
            backdrop: "rgba(0,0,0,0.4)",
            willClose: () => {
              setLoader(false);
            },
          })
          .then((result) => {
            if (result.isConfirmed) {
              if (result.value?.error) {
                newSwal.fire({
                  html: `
                    <div class="swal-modal-header">
                      <div class="swal-modal-icon-wrap swal-modal-icon-wrap--error">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"
                          fill="none" stroke="#f87171" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <line x1="18" y1="6" x2="6" y2="18"/>
                          <line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                      </div>
                      <h3 class="swal-modal-heading">Session Not Closed</h3>
                      <p class="swal-modal-desc">Unable to close the session.</p>
                    </div>
                  `,
                });
              } else {
                newSwal.fire({
                  html: `
                    <div class="swal-modal-header">
                      <div class="swal-modal-icon-wrap swal-modal-icon-wrap--success">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"
                          fill="none" stroke="#34d399" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                      </div>
                      <h3 class="swal-modal-heading">Session Closed</h3>
                      <p class="swal-modal-desc">The session has been successfully closed.</p>
                    </div>
                  `,
                });
              }
            }
          });
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setLoader(false);
      });
  };

  const handleCloseDay = (e) => {
    e.preventDefault();
    navigate("END_OF_DAY_SUMMARY_PAGE");
    setOpen(false);
  };

  const handleFlush = () => {
    if (!cartId) return;
    const newFlushPayload = {
      cartId: cartId,
      updatedBy: retailUserDetails?.uidx,
      updatedByName: localStorage.getItem("user_name"),
    };
    flushCartNew(newFlushPayload)
      .then((res) => {
        const totalItems = cartItems.reduce(
          (totalQuantity, item) => totalQuantity + item.quantity,
          0
        );
        const metaData = {
          cartId: cartId,
          itemsCount: totalItems,
          amount: total,
        };
        eventTracker({ metaData, eventType: eventTrackerConstant.CART_DELETED });
        dispatch(resetStateWithoutTime(0));
        const backupData = {
          ...orderMetricDataFullState,
          manuallyAdded: 0,
          scannedProduct: 0,
          isMultipleBatch: false,
          avgProductAddTime: "",
          totalProducts: 0,
          productTimeArray: [],
          editOrderItem: 0,
          manuallyRemovedItems: 0,
          manualItemsGtin: [],
        };
        localStorage.setItem("orderMetricData", JSON.stringify(backupData));
        dataRetriveWhenPageRefresh(cartId).then((res) => {
          setCartId(res?.data?.data?.data?.cartId);
          setOfferFound(res?.data?.data?.data?.offerProductFound);
          setCartItems(res?.data?.data?.data?.cartProducts);
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing?.sgst);
          setCess(res?.data?.data?.data?.billing?.totalCessAmount);
          setSubTotal(res?.data?.data?.data?.billing?.subtotal);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          dispatch(addcoupon("-----"));
        });
      })
      .catch((err) => {
        // showSnackbar(err?.message || err?.response?.data?.message, "error");
        setLoader(false);
      });
  };

  const handleClose = () => setOpen(false);

  const handleShowManager = (e) => {
    if (!cPin) {
      e.preventDefault();
      return;
    }
    e.preventDefault();
    setCashierLoader(true);
    let payload = {
      mobile: mobileNumber,
      primaryPassword: cPin,
    };
    validateManagerPin(payload)
      .then((res) => {
        setCashierLoader(false);
        setManagerBox(true);
      })
      .catch((err) => {
        setCashErrMessage(err?.response?.data?.message);
        setCashierLoader(false);
      });
  };

  const handleCancel = () => {
    dispatch(addmanageruidx(""));
    handleClose();
  };

  const handleCashierPin = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 4);
    dispatch(addpin(val));
    setCPin(val);
  };

  const handleManagerPin = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 4);
    setMPin(val);
  };

  return (
    <>
      {/* ── NEW modal wrapper with updated UI ── */}
      <div className="manager-modal-overlay">
        <div className="manager-modal-card">
          {/* ── Close (X) button ── */}
          <button className="manager-modal-close-btn" type="button" onClick={handleCancel}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>

          {/* ── Dark header ── */}
          <div className="manager-modal-header">
            <div className="manager-modal-lock-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#60a5fa"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="16" r="1" />
                <rect x="3" y="10" width="18" height="12" rx="2" />
                <path d="M7 10V7a5 5 0 0 1 10 0v3" />
              </svg>
            </div>
            <h3 className="manager-modal-title">
              {manageBox && manageBox ? "Manager Access" : "Cashier Access"}
            </h3>
            <p className="manager-modal-subtitle">Authorization required to close session</p>
          </div>

          {/* ── Body ── */}
          <div className="manager-modal-body">
            {!manageBox ? (
              /* ── Step 1: Cashier PIN ── */
              <form onSubmit={handleShowManager}>
                <div className="manager-modal-field-group">
                  <label className="manager-modal-label">Cashier PIN</label>
                  <div className="manager-modal-pin-wrapper">
                    <Input
                      id="outlined-adornment-password"
                      type={isVisible ? "number" : "password"}
                      className="manager-modal-pin-input numberInput1"
                      onChange={(e) => handleCashierPin(e)}
                      value={cPin}
                      inputProps={{ inputMode: "numeric", maxLength: 4 }}
                      placeholder="••••"
                      disableUnderline
                      autoFocus
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={toggle}
                            edge="end"
                          >
                            {isVisible ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Pin"
                    />
                  </div>
                  {errCashMessage ? <p className="err-msg-text">{errCashMessage}</p> : null}
                </div>

                <div className="manager-modal-actions">
                  <Button onClick={handleCancel} className="manager-modal-cancel-btn" type="button">
                    Cancel
                  </Button>
                  <Button
                    className={
                      cashierPin.length < 4
                        ? "manager-modal-submit-btn manager-modal-submit-btn--disabled"
                        : "manager-modal-submit-btn"
                    }
                    type="submit"
                  >
                    {cashierLoader ? <CircularProgress size={22} sx={{ color: "#fff" }} /> : "Next"}
                  </Button>
                </div>
              </form>
            ) : (
              /* ── Step 2: Manager select + PIN ── */
              <form onSubmit={closeTabName === "session" ? handleCloseSession : handleCloseDay}>
                {/* Manager select */}
                <div className="manager-modal-field-group manager-auth-select-container">
                  <label className="manager-modal-label">Select Manager</label>
                  <StyledSelect
                    className="manager-auth-select"
                    menuPortalTarget={null}
                    onChange={(e) => {
                      dispatch(addmanageruidx(e.value));
                      setSelectedManager(e.label);
                    }}
                    options={managerDetails}
                    placeholder={!isMobile ? "Use arrow key to select manager" : "Select"}
                  />
                </div>

                {/* Manager PIN */}
                <div className="manager-modal-field-group">
                  <label className="manager-modal-label">Enter PIN</label>
                  <div className="manager-modal-pin-wrapper">
                    <Input
                      id="outlined-adornment-password"
                      type={isVisibleManager ? "number" : "password"}
                      className="manager-modal-pin-input numberInput1"
                      inputProps={{ inputMode: "numeric", maxLength: 4 }}
                      value={mPin}
                      autoComplete="new-password"
                      placeholder="••••"
                      disableUnderline
                      onChange={(e) => handleManagerPin(e)}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={toggle1}
                            edge="end"
                          >
                            {isVisibleManager ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Pin"
                    />
                  </div>
                  {errMessage ? <p className="err-msg-text">{errMessage}</p> : null}
                </div>

                {/* Verify & Close Session button */}
                <StyledButton
                  loading={loader}
                  disabled={mPin.length < 4 || !managerNumber}
                  type="submit"
                  className="manager-modal-verify-btn"
                >
                  {loader ? (
                    <CircularProgress size={22} sx={{ color: "#fff" }} />
                  ) : (
                    "Verify & Close Session"
                  )}
                </StyledButton>

                {/* OR divider */}
                <div className="manager-modal-divider">
                  <span className="manager-modal-divider-line" />
                  <span className="manager-modal-divider-text">Or</span>
                  <span className="manager-modal-divider-line" />
                </div>

                {/* Swipe card placeholder (UI only – no functionality change) */}
                <button type="button" className="manager-modal-swipe-btn" disabled>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="manager-modal-swipe-icon"
                  >
                    <path d="M3 7V5a2 2 0 0 1 2-2h2" />
                    <path d="M17 3h2a2 2 0 0 1 2 2v2" />
                    <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
                    <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
                  </svg>
                  <span className="manager-modal-swipe-label">Swipe Manager Card</span>
                </button>

                {/* Cancel link */}
                <div className="manager-modal-actions manager-modal-actions--center">
                  <StyledButton
                    onClick={handleCancel}
                    className="manager-modal-cancel-btn"
                    type="button"
                  >
                    Cancel
                  </StyledButton>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SliderTabManager;
